import classNames from "classnames";
import { useTranslation } from "react-i18next";

import OutlinedButton from "../../../../common/OutlinedButton";
import PrimaryButton, {
  PrimaryButtonType,
} from "../../../../common/PrimaryButton";
import { IDeleteContractProps } from "../../models";
// styles
import styles from "./deleteContract.module.scss";

export const DeleteContractForm = (props: IDeleteContractProps) => {
  const { onDelete, onCancel } = props;
  const { t } = useTranslation();
  return (
    <div>
      <div className={styles.description}>
        {t("lbl_delete_modal_description")}
      </div>
      <div className={styles.btnContainer}>
        <OutlinedButton onClick={onCancel}>
          <p className={classNames("subtitle2", "primary")}>
            {t("lbl_delete_modal_buttons_cancel")}
          </p>
        </OutlinedButton>
        <PrimaryButton
          id={`contract_details_delete_contract_confirm`}
          buttonType={PrimaryButtonType.DANGER}
          onClick={onDelete}>
          {t("lbl_delete_modal_buttons_delete")}
        </PrimaryButton>
      </div>
    </div>
  );
};
